<template>
  <div class="col-12 mt-5">
    <app-overlay-loader v-if="preloader"/>
    <form ref="form" data-url="/form/input" class="mb-0" :class="{'loading-opacity': preloader}">

      <div class="form-group row align-items-center">
        <label for="inputs_form_revision_id" class="col-4">
          {{ $t("select_forms") }}
        </label>
        <app-input type="checkbox"
                   class="col-8"
                   :list="formsList"

                   v-model="inputs.form_revision_id"/>
      </div>

      <div class="form-group row align-items-center">
        <label for="inputs_guest_uuid" class="col-4">
          {{ $t("form_link") }}
        </label>
        <app-input
            id="generate_form_link"
            class="col-7"
            type="text"
            ref="public_link"
            v-model="inputs.public_link"
            :disabled="true"
        />
        <textarea type="text" class="d-none" id="public_link_text" readonly="readonly">
            {{ inputs.public_link }}
        </textarea>
        <a href="#"
           class="default-font-color col-1"
           data-toggle="tooltip"
           data-placement="top"
           data-copy="clipboard"
           title="$t('copy_to_clipboard')"
           @click.prevent="copyToClipboard('public_link_text')">
          <app-icon name="clipboard"/>

        </a>
      </div>

      <div class="form-group row align-items-center">
        <label for="inputs_response_limit" class="col-4">
          {{ $t("response_limit") }}
        </label>
        <app-input type="radio-buttons"
                   class="col-8"
                   :list="responseLimit"
                   v-model="inputs.type"/>
      </div>
      <hr>
      <div class="mb-3 float-right action-buttons">
      <app-button :label="$t('generate_link')" class-name="btn-success mr-2" :is-disabled="false"
                  @submit="generateLink"/>

     </div>
      <div class="mt-5 form-group row align-items-center" style="clear:both">
        <label for="text_email" class="col-4">
          {{ $t('emails') }}
        </label>
        <div class="tags-input col-8">
          <input type="text" placeholder="Enter email and press enter to confirm" id="tags-input" v-model="inputs.newEmail" @keydown.enter.prevent="addEmail">
          <ul>
            <li v-for="(email, index) in inputs.emails" :key="index">
              {{ email }} <span class="remove-tag" @click="removeEmail(index)">x</span>
            </li>
          </ul>
        </div>

      </div>

      <div class="mt-5 form-group row align-items-center" style="clear:both">
        <label for="form_email_template" class="col-4">
          {{ $t('form_email_template') }}
        </label>
        <app-input id="form_email_template"
                   class="col-8"
                   type="text-editor"
                   v-model="inputs.form_email_template"
                   :placeholder="$t('Please input email content for the recipients.')"/>

      </div>

      <div class="float-right action-buttons">
        <app-button :label="$t('send_invitation_link')" class-name="btn-info mr-2" :is-disabled="false"
                    @submit="generateLink"/>

      </div>
    </form>




  </div>
</template>

<script>

import {axiosGet, axiosPost} from "@/app/Helpers/AxiosHelper";
import {
   ASSIGN_PUBLIC_FORM
} from "@/app/Config/ApiUrl";
import CoreLibrary from "@/core/helpers/CoreLibrary";
import GlobalHelperMixin from "@/app/Mixins/global/GlobalHelperMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import CopyToClipboard from "@/app/Helpers/CopyToClipboard";
export default {
  extends: CoreLibrary,
  name: "AssignTaskForm",
  mixins: [FormMixin, GlobalHelperMixin],
  data() {
    return {
      inputs: {
        newEmail : '',
        emails : []
      },
      preloader: false,
      getPublicFormLink: ASSIGN_PUBLIC_FORM,
      responseLimit:[
        {id:0, value:'Single response'},{id:1, value:'Multiple response'}
      ],
      activeList:[
        {id:"0", value:'In-Active'},{id:"1", value:'Active'}
      ],
    };
  },
  created() {
  },
  methods: {
    copyToClipboard(id) {
      CopyToClipboard.copyDom(id);
      this.$toastr.s(this.$t('successfully_copied_message'));
    },
    generateLink(){
      this.preloader = true
      this.inputs.task_id = this.taskId
      axiosPost(ASSIGN_PUBLIC_FORM, this.inputs)
          .then((res) => {
            this.$toastr.s(res.data.message);
            this.inputs.public_link = res.data.public_link;
            this.preloader = false
          })
          .catch((errors) => {
            this.$toastr.s(res.data.message);

          }).finally(() => {
        this.preloader = false
        // this.$hub.$emit("reload-" + this.tableId);
      });
    },
    getLinkData(){
      this.preloader = true
      axiosPost(ASSIGN_PUBLIC_FORM + '/'+ this.taskId).then( (res) => {
        this.inputs.public_link = res.data.public_link
        this.preloader = false
      }).catch((errors) => {

      }).finally((res) => {
        this.preloader = false

      });
    },
    addEmail() {
      if (this.inputs.newEmail && !this.inputs.emails.includes(this.inputs.newEmail)) {
        this.inputs.emails.push(this.inputs.newEmail);
        this.inputs.newEmail = '';
      }
    },
    removeEmail(index) {
      this.inputs.emails.splice(index, 1);
    },
  },
  mounted() {
    this.getLinkData();
    console.log("Form Revision ",this.form_revision_id)
    console.log("Type ",this.type)
  },
  computed:{
    form_revision_id(){
      return this.inputs.form_revision_id
    },
    type(){
      return this.inputs.type
    },
    formsList(){
      let list = [];
      let jsonString = this.$store.state.sharedData.sharedData.taskForms;
      let forms = JSON.parse(jsonString);
      if (typeof forms.data === 'object'){
        forms.data.forEach(function(data){
          let formObj = {id:data.id, value:data.form.name }
          list.push(formObj)
        });
      }

      return list
    },
    selectedForm(){
      return this.$store.state.sharedData.sharedData.taskFormData
    },
    taskId(){
      return this.$store.state.sharedData.sharedData.taskId

    }
  },
};
</script>
<style scoped>
.tags-input {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid #ccc;
  padding: 5px;
}

.tags-input input {
  border: none;
  flex: 1;
  margin-right: 5px;
}

.tags-input ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}

.tags-input li {
  background-color: #eee;
  border-radius: 4px;
  padding: 2px 6px;
  margin-right: 5px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.tags-input .remove-tag {
  margin-left: 5px;
  cursor: pointer;
}
</style>
